export const userSettingsTranslations = {
  profile_saved: 7527,
  done: 7338,
  sub_title: 7529,
  main_title: 7794,
  location: 8025,
  usergroup: 8024,
  unit: 8026,
  language: 5336,
  name: 7533,
  email: 7532,
  must_be_filled: 5949,
  must_be_equal: 7681,
  search: 7345,
  cancel_changes: 7558,
  undo_all: 5792,
  go_back_to_profile: 7560,
  are_you_sure: 7460,
  old_password: 3627,
  change_password: 3637,
  new_password: 3628,
  repeat_new_password: 3629,
  change: 5432,
  password_changed: 7673,
  about_close: 4329,
  validation_error: 7702,
  info_text_location: 8027,
  info_text_unit: 8028,
  edit_veracity_profile: 8401,
  save: 5589,
  cancel: 7956
};

export type UserSettingsTranslation = {
  readonly [T in keyof typeof userSettingsTranslations]: string
};
